import * as React from 'react';

function SvgPartIcon(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7 14A7 7 0 117 0a7 7 0 010 14zm0-1A6 6 0 107 1a6 6 0 000 12zm3.938-6.588a.587.587 0 110 1.176h-3.35v3.35a.587.587 0 11-1.176 0v-3.35h-3.35a.588.588 0 010-1.176h3.35v-3.35a.588.588 0 011.176 0v3.35h3.35z" />
    </svg>
  );
}

export default SvgPartIcon;
